import React from 'react'
import { Route, Switch } from 'react-router'
import { GenerateActivationCodes } from './pages/GenerateActivationCodes'

export const ActivationCodeRouter = () => (
  <Switch>
    <Route exact path='/activation-codes' component={GenerateActivationCodes} />
  </Switch>
)
